import type { PartnerInfo } from '@@partner:types:app'

/*
  Account helper functions
*/

export const checkIsLoggedIn = (partnerInfo: PartnerInfo) => !!partnerInfo?.id
